import { render, staticRenderFns } from "./TextareaGroup.vue?vue&type=template&id=11b5d89f"
import script from "./TextareaGroup.vue?vue&type=script&lang=js"
export * from "./TextareaGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports